import { Map } from 'immutable';

import { CREATE_CONNECTION, DESTROY_CONNECTION } from 'OPENTOK/action_types';
import { Connection } from 'OPENTOK/models';

const connections = (state = new Map({}), action) => {
  switch (action.type) {
    case CREATE_CONNECTION:
      return state.set(
        action.id,
        new Connection({
          id: action.id,
          ...action.payload,
        }),
      );
    case DESTROY_CONNECTION:
      return state.delete(action.id);
    default:
      return state;
  }
};

export default connections;
